import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { ModalidadContacto, ObjetivoVisita, Visita } from '../../services/visitas.service';
import { formatearModalidadContacto, formatearObjetivosVisita } from '../../utils/visita-registro.util';

export interface ResumenVisitaPdfMeta {
  fecha_emision?: string | null;
  extensionista?: string | null;
}

@Component({
  selector: 'app-resumen-visita-pdf',
  templateUrl: './resumen-visita-pdf.component.html',
  styleUrls: ['./resumen-visita-pdf.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResumenVisitaPdfComponent {
  @Input() visita: Visita | null = null;
  @Input() meta: ResumenVisitaPdfMeta | null = null;
  @Input() logoSrc: string = 'assets/logo-indap.png';
  @Input() objetivosCatalogo: ObjetivoVisita[] = [];
  @Input() modalidadesCatalogo: ModalidadContacto[] = [];

  formatearFecha(fechaISO: string | null | undefined): string {
    if (!fechaISO) return '-';
    const d = new Date(fechaISO);
    return d.toLocaleDateString('es-CL', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  formatearHora(fechaISO: string | null | undefined): string {
    if (!fechaISO) return '-';
    const d = new Date(fechaISO);
    return d.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' });
  }

  formatearFechaLarga(fechaISO: string | null | undefined): string {
    if (!fechaISO) return '-';
    const d = new Date(fechaISO);
    const day = d.getDate().toString().padStart(2, '0');
    const months = [
      'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
      'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
    ];
    const month = months[d.getMonth()];
    const year = d.getFullYear();
    return `${day} ${month} ${year}`;
  }

  lineasCompromisos(compromisos: string | null | undefined): string[] {
    if (!compromisos?.trim()) return [];
    return compromisos
      .split(/\n|•|[-–—]/)
      .map(s => s.trim())
      .filter(Boolean);
  }

  textoObjetivosVisita(): string {
    return formatearObjetivosVisita(this.visita, this.objetivosCatalogo) || '-';
  }

  textoModalidadContactoVisita(): string {
    return formatearModalidadContacto(this.visita, this.modalidadesCatalogo) || '-';
  }

  get ahora(): string {
    const d = new Date();
    const fecha = d.toLocaleDateString('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
    const hora = d.toLocaleTimeString('es-CL', { hour: '2-digit', minute: '2-digit' });
    return `${fecha} a las ${hora}hrs`;
  }
}
